import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, type State, TalkingPointsStore } from './TalkingPointsStore';

export const useTalkingPointsActions = createActionsHook<State, Actions>(TalkingPointsStore);
